// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Yr-z","tooltipWrapper":"Zr-z","icon":"_r-z","tooltip":"as-z","content":"bs-z"};